import thunk from 'redux-thunk';
import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
// import {logger} from 'redux-logger'
import rootReducer from './reducers';

export const history = createHistory();

let middlewareList = [thunk, routerMiddleware(history)];

// if (process.env.NODE_ENV !== 'production') {
//  middlewareList.unshift(logger);
// }

const middleWare = applyMiddleware(...middlewareList);

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, /* preloadedState, */ composeEnhancers(middleWare));

export default store;

if (window.Cypress) {
  window.reduxStore = store;
}



// WEBPACK FOOTER //
// ./src/store.js